<template>
  <div>
    <div class="header">
      <div class="img" v-show="videoImgShow" @click="play()">
        <img
          :src="courseData.TitleImage !=null?courseData.TitleImage +'?x-oss-process=image/resize,m_fill,h_400,w_750':defaultImg"
          :onerror="defaultImg"
          alt
          v-show="videoImgShow"
        >
      </div>
      <video
        controls="controls"
        playsinline
        width="100%"
        type="video/mp4"
        style="background-size:cover;"
        id="videoImg"
        v-show="!videoImgShow"
        :src="courseData.AttachmentPath"
      ></video>
    </div>
    <div class="study-title">
      <h5>{{courseData.Title}}</h5>
      <span>主讲人：{{courseData.ExpertName}}</span>
    </div>
    <div class="study-info">
      <h5>个人简介</h5>
      <p>{{courseData.Summary}}</p>
    </div>
    <div class="study-info">
      <h5>课程介绍</h5>
      <div
        v-html="courseData.Description"
        class="article-content"
        id="article"
        :class="isHeightAuto? 'article-active':''"
      ></div>
    </div>

    <footer-logo/>
    <detail-footer type="study" :resource-id="searchData.ID" :share-data="returnInfo"/>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import detailFooter from '@/components/DetailFooter.vue'
export default {
  components: {
    'footer-logo': footerLogo,
    detailFooter
  },
  data() {
    return {
      videoImgShow: true,
      shareShow: {
        isShow: false
      },
      returnInfo: {
        title: '',
        desc: '',
        link: location.href,
        image: ''
      },
      searchData: {
        ID: this.$route.query.id
      },
      courseData: {},
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  created() {
    var studyId = this.$route.params.id
    if (!studyId) studyId = this.$route.query.id
    this.searchData.ID = studyId

    this.getCourseInfo()
  },
  methods: {
    play() {
      this.videoImgShow = false
      document.getElementById('videoImg').play()
    },
    onShow() {
      this.shareShow.isShow = true
    },
    getCourseInfo() {
      this.$fetch('/api/Course/GetCourseDetail/', this.searchData).then(result => {
        this.loadstate = false
        this.courseData = result
        this.returnInfo.title = result.Title
        this.returnInfo.desc = result.Summary
        this.returnInfo.image = result.TitleImage

        document.title = result.Title
      })
    }
  }
}
</script>

<style lang="less" scoped>
.article-content {
  padding: 20 / @rem-size 24 / @rem-size 0;
}

.header {
  width: 100%;
  height: 360 / @rem-size;
  background: #333;

  video {
    width: 100%;
    height: 100%;
  }

  .img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    &::after {
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      margin: auto;
    }

    &::before {
      display: block;
      content: '';
      width: 80 / @rem-size;
      height: 80 / @rem-size;
      background-image: url('../../assets/images/play-icon.png');
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      margin: auto;
      z-index: 30;
    }
  }
}

.study-title {
  width: 100%;
  height: auto;
  background: #fff;
  padding: 16 / @rem-size 24 / @rem-size 30 / @rem-size;
  border-bottom: 20 / @rem-size solid #f7f7f7;

  h5 {
    font-size: 32 / @rem-size;
    color: #333;
    font-weight: normal;
  }

  span {
    display: block;
    font-size: 28 / @rem-size;
    color: #999;
    margin-top: 15 / @rem-size;
  }
}

.study-info {
  background: #fff;
  border-bottom: 20 / @rem-size solid #f7f7f7;

  h5 {
    font-size: 32 / @rem-size;
    color: #000033;
    padding-left: 46 / @rem-size;
    line-height: 71 / @rem-size;
    border-bottom: 1px solid #e5e5e5;
    font-weight: normal;
    position: relative;

    &::after {
      display: block;
      content: '';
      width: 4 / @rem-size;
      height: 32 / @rem-size;
      background: #005fd5;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 24 / @rem-size;
      margin: auto;
    }
  }

  p {
    padding: 10 / @rem-size 24 / @rem-size 24 / @rem-size;
    line-height: 40 / @rem-size;
    font-size: 28 / @rem-size;
  }
}

footer {
  width: 100%;
  height: 98 / @rem-size;
  background: #fff;
  box-shadow: 0 0 18 / @rem-size 0 rgba(208, 208, 208, 0.2);
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 8 / @rem-size 46 / @rem-size 0;

  ul {
    display: flex;
    justify-content: space-between;

    li {
      &:active {
        opacity: 0.8;
      }

      span {
        display: block;
        color: #999;
        font-size: 24 / @rem-size;
        margin-top: 8 / @rem-size;
      }
    }
  }
}
</style>
